import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Receipt, Package } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

export type PurchaseMode = "multi" | "single";

interface PurchaseModeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (mode: PurchaseMode) => void;
}

export function PurchaseModeModal({ open, onOpenChange, onSelect }: PurchaseModeModalProps) {
  const { tDynamic } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{tDynamic("I purchased supplies")}</DialogTitle>
          <DialogDescription>
            {tDynamic("Choose how to log this purchase")}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 py-2">
          <Button
            type="button"
            variant="outline"
            className="h-auto py-4 px-4 justify-start gap-3 text-left"
            onClick={() => {
              onSelect("multi");
              onOpenChange(false);
            }}
          >
            <Receipt className="w-5 h-5 shrink-0" />
            <div>
              <p className="font-medium">{tDynamic("One receipt (multiple items)")}</p>
              <p className="text-xs text-muted-foreground">
                {tDynamic("Upload one receipt, enter total, add items for inventory")}
              </p>
            </div>
          </Button>
          <Button
            type="button"
            variant="outline"
            className="h-auto py-4 px-4 justify-start gap-3 text-left"
            onClick={() => {
              onSelect("single");
              onOpenChange(false);
            }}
          >
            <Package className="w-5 h-5 shrink-0" />
            <div>
              <p className="font-medium">{tDynamic("One item (quick)")}</p>
              <p className="text-xs text-muted-foreground">
                {tDynamic("Log a single item reimbursement")}
              </p>
            </div>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
